import React from "react";
import LabelWithTooltip from "./LabelWithTooltip";
import {Filter, X} from "react-bootstrap-icons";

/**
 * Renders a filter indicator showing how many table rows are filtered against the total
 */
export default function FilterResult(props) {
    const showClearButton = props.showClearButton;
    const clearFunc = props.clearFunc;
    const displayed = props.displayed;
    const total = props.total;

    return <span className={'float-right'}>
                {showClearButton &&
                    <LabelWithTooltip label={
                        <span onClick={clearFunc}>
                            <Filter className={"react-icons canopia"} size={'1.8em'} style={{paddingBottom: "2px"}}/>
                            <X className={"react-icons canopia6"} size={'1.6em'} style={{paddingBottom: "2px", marginLeft: "-14px", marginBottom: "-7px"}}/>
                        </span>
                    } text={'Clear all filters'} className={'canopia-icon-with-legend'}>
                    </LabelWithTooltip>
                }
        {/*{displayed && displayed === total && <span style={{marginLeft: '8px', fontSize: '11px'}}>No active filter: total {total}</span>}*/}
        {displayed && displayed < total && <span style={{marginLeft: '8px', fontSize: '11px'}}>Active filter(s), showing {displayed} / {total}</span>}
    </span>
}
